import Vue from "vue";
import VueRouter from "vue-router";
import error404 from "@/404";
import axios from "@/plugins/axios.js";

Vue.use(VueRouter);
Vue.use(axios);

const requireAdmin = (to, from, next) => {
  if (!localStorage.getItem("adminId")) {
    next("/admin/login");
  } else {
    next();
  }
};

const requireReg = (to, from, next) => {
  if (sessionStorage.getItem("pOrder")) {
    var progressOrder = sessionStorage.getItem("pOrder");
    var pathArray = to.fullPath.split("/");
    var length = pathArray.length;
    if (
      progressOrder.indexOf(pathArray[length - 1]) >
      progressOrder.indexOf(sessionStorage.getItem("step"))
    ) {
      alert(
        "이전 과정을 먼저 진행해 주세요. \n마지막으로 진행했던 과정으로 돌아갑니다."
      );
      if (sessionStorage.getItem("step")) {
        next(`/admin/reg/${sessionStorage.getItem("step")}`);
      } else {
        next("/admin/reg/init");
      }
      return false;
    } else {
      next();
    }
  } else {
    next();
  }
};

const routes = [
  {
    // 404 페이지
    path: "*",
    component: error404,
  },
  // 어드민을 /경로로 넣고 기본 url 탈때 리스트로 자동 redirect
  { path: "/", redirect: { name: "list-main" } },
  { path: "/admin", redirect: { name: "list-main" } },
  { path: "/admin/reg", redirect: { name: "reg-init" } },
  { path: "/admin/list", redirect: { name: "list-main" } },
  {
    path: "/admin/login",
    name: "login",
    component: () => import("@/pages/login.vue"),
  },
  {
    path: "/admin/fixAdminPW/:time/:email/:code",
    name: "fixAdminPW",
    component: () => import("@/pages/fixAdminPW.vue"),
  },
  {
    path: "/admin",
    name: "Admin",
    component: () => import("@/pages/admin.vue"),
    beforeEnter: requireAdmin,

    children: [
      {
        // 등록 페이지 분류
        path: "reg",
        name: "reg",
        component: () => import("@/pages/reg.vue"),
        beforeEnter: requireReg,
        children: [
          {
            path: "init",
            name: "reg-init",
            component: () => import("@/pages/reg/init.vue"),
          },
          {
            path: "input",
            name: "reg-input",
            component: () => import("@/pages/reg/input.vue"),
          },
          {
            path: "agree",
            name: "reg-agree",
            component: () => import("@/pages/reg/agree.vue"),
          },
          {
            path: "info",
            name: "reg-info",
            component: () => import("@/pages/reg/info.vue"),
          },
          {
            path: "enroll",
            name: "reg-enroll",
            component: () => import("@/pages/reg/enroll.vue"),
          },
          {
            path: "userInfo",
            name: "reg-userInfo",
            component: () => import("@/pages/reg/userInfo.vue"),
          },
          {
            path: "purchase",
            name: "reg-purchase",
            component: () => import("@/pages/reg/purchase.vue"),
          },
          {
            path: "complete",
            name: "reg-complete",
            component: () => import("@/pages/reg/complete.vue"),
          },
          {
            path: "setPopup",
            name: "reg-setPopup",
            component: () => import("@/pages/reg/setPopup.vue"),
          },
        ],
      },
      {
        // 리스트(관리) 페이지 분류
        path: "list",
        name: "list",
        component: () => import("@/pages/list.vue"),
        children: [
          {
            path: "main",
            name: "list-main",
            component: () => import("@/pages/list/main.vue"),
          },
          {
            path: "applyList",
            name: "list-applyList",
            component: () => import("@/pages/list/applyList.vue"),
          },
          {
            path: "fixProgram",
            name: "list-fixProgram",
            component: () => import("@/pages/list/fixProgram.vue"),
          },
        ],
      },
      {
        path: "guide",
        name: "guide",
        component: () => import("@/pages/guide.vue"),
      },
      {
        path: "checkList",
        name: "checkList",
        component: () => import("@/pages/checkList.vue"),
      },
      {
        path: "mailPad",
        name: "mailPad",
        component: () => import("@/pages/mailPad.vue"),
      },
      {
        path: "beforeUserReg",
        name: "beforeUserReg",
        component: () => import("@/pages/beforeUserReg.vue"),
      },
      {
        path: "qna",
        name: "qna",
        component: () => import("@/pages/qna.vue"),
      },
      {
        path: "search",
        name: "search",
        component: () => import("@/pages/search.vue"),
      },
      {
        // 미리보기 페이지 분류
        path: "preview",
        name: "preview",
        component: () => import("@/pages/preview.vue"),
        children: [
          {
            path: "input",
            name: "preview-input",
            component: () => import("@/pages/preview/input.vue"),
          },
          {
            path: "agree",
            name: "preview-agree",
            component: () => import("@/pages/preview/agree.vue"),
          },
          {
            path: "info",
            name: "preview-info",
            component: () => import("@/pages/preview/info.vue"),
          },
          {
            path: "enroll",
            name: "preview-enroll",
            component: () => import("@/pages/preview/enroll.vue"),
          },
          {
            path: "userInfo",
            name: "preview-userInfo",
            component: () => import("@/pages/preview/userInfo.vue"),
          },
          {
            path: "purchase",
            name: "preview-purchase",
            component: () => import("@/pages/preview/purchase.vue"),
          },
          {
            path: "complete",
            name: "preview-complete",
            component: () => import("@/pages/preview/complete.vue"),
          },
          {
            path: "fixProgram",
            name: "preview-fixProgram",
            component: () => import("@/pages/preview/fixProgram.vue"),
          },
        ],
      },
    ],
  },
  {
    // 당근농장 어드민 자동 로그인(GET 용)
    path: "/users/carrot-login",
    name: "users-carrot-login",
    component: () => import("@/pages/carrotLogin.vue"),
  },
  {
    // 당근농장 어드민 자동 로그인(POST 용)
    path: "/users/carrot-login-post",
    name: "users-carrot-login-post",
    component: () => import("@/pages/carrotLoginPost.vue"),
  },
  {
    // 윈도우 팝업용
    path: "/admin/list/applyList/addList",
    name: "list-applyList-list",
    component: () => import("@/components/list/addListWindow.vue"),
  },
  {
    // 윈도우 팝업용
    path: "/admin/list/applyList/add",
    name: "list-applyList-add",
    component: () => import("@/components/list/addWindow.vue"),
  },
  {
    // 윈도우 팝업용
    path: "/admin/list/qna/mailpad",
    name: "list-qna-mailpad",
    component: () => import("@/components/qna/mailpadWindow.vue"),
  },
];

const router = new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  mode: "history",
  routes,
});

router.afterEach(() => {
  // Check if a new cache is available on page load.
  window.addEventListener(
    "load",
    function () {
      window.applicationCache.addEventListener(
        "updateready",
        function () {
          if (
            window.applicationCache.status ==
            window.applicationCache.UPDATEREADY
          ) {
            // Browser downloaded a new app cache.
            // Swap it in and reload the page to get the new hotness.
            window.applicationCache.swapCache();
            window.location.reload();
          } else {
            // Manifest didn't changed. Nothing new to server.
          }
        },
        false
      );
    },
    false
  );
});

export default router;
